/**
 * Created by XUQIANG on 2016/4/22.
 */
export default {
  re_title: 'Visical-Booking',
  title_log: 'Intelligent Meeting',
  dialog_btn_ok: 'OK',
  dialog_btn_cancel: 'Cancel',
  dialog_btn_know: 'Got it',
  dialog_prompt_info: 'Notice',
  dialog_warning_info: 'Alert',
  dialog_error_info: 'Error',
  dialog_success_info: 'Success',
  country_china: 'China +86',
  country_china_hk: 'Hong Kong,China +852',

  count: 'count',
  num_of_day: "Number of days",

  btn_close: 'Close',
  btn_approval: 'Approval',
  btn_reject: 'Reject',
  btn_save: 'Save',

  topic: 'Topic',

  pls_select: 'Please Select',

  //首页国际化
  index_registration: 'Sign Up',
  index_company: 'Company',
  index_company_name: 'Company name',
  index_company_domain: "Company's domain",
  index_company_account: 'Account name',
  index_company_email: 'Mailbox',
  index_company_phone: 'Mobile',
  index_username: 'Name',
  index_email: 'Mailbox',
  index_phone: 'Mobile',
  index_staffID: 'Staff ID',
  index_image_content: 'Security image',
  index_password_prompt: 'Password(8-digits)',
  index_password_conform: 'Confirm password (same to Password)',
  index_agree: 'Accept the term of software license policy ',
  index_previous: 'Previous',
  index_next: 'Next',
  index_login_username: 'User Name',
  index_login_password: 'Password',
  index_login_basedn: 'BaseDN',
  index_login_check_code: 'Verify Code',
  index_remember: 'Remember password',
  index_forgot: 'Forgot password ?',
  index_register_account: 'New account',
  index_un_username: 'Please input username ',
  index_un_password: 'Please input password',
  index_find_password: 'Find my password',
  index_find_email: 'Mailbox',
  index_send: 'Send',
  index_or: 'OR',
  index_find_phone: 'Mobile',
  index_valid_code: 'Validation code ',
  index_valid_prompt: 'Validation error: Mailbox is incorrect',
  index_submit: 'Submit',

  continue_extend: 'Continue',

  index_activation: 'Activation',
  index_tip_email: 'Mailbox successful',
  index_valid_phone: 'Mobile successful',
  index_tip_email_title: 'Mailbox successful',
  index_valid_phone_title: 'Mobile successful',
  index_complete: 'Finish',

  index_reset_password: 'Reset password',
  index_save_continue: 'Save and Continue',

  index_logo_virsical: 'Virsical',
  index_login: 'Login',
  index_reservation_platform: 'Smart Meeting',
  index_help: 'Help',
  index_download: 'Download Center',
  index_language_shift: 'Chinese-English switch',
  index_language_chinese: 'Chinese',
  index_language_chineseHk: 'Traditional Chinese',
  index_language_english: 'English',
  index_login_off: 'Logout',
  index_domain_success: 'Register successful, Please login and activate It',
  index_domain_msm: 'Validation code is sent, Please Check It !',
  emil_sent: 'The message has been sent, please check!',
  index_experience: 'Free &Try it',
  index_experience_0: 'Free &',
  index_experience_1: ' ',
  index_experience_2: 'Try It',
  index_experience_3: ' ',
  index_select_number: 'Participant',
  index_select_0: 'Unlimited',
  index_select_1: '1-3 ',
  index_select_2: '4-9',
  index_select_3: '10+ Above',
  index_search: 'Search',
  index_reset: 'Reset',
  index_un_resource: 'Please select what is you want to book',
  index_un_start: 'Please select start of time',
  index_un_end: 'Please select end of time',
  index_un_number: 'Please select participant',
  index_search_beijing: 'What is you want to book  ',
  startPlaceholder: 'Start ',
  endPlaceholder: 'End ',

  start_greater_than_end: "The appointment start date should not be greater than the end date",
  start_greater_then_end_one_month: 'Query time should not exceed one month',
  main_search_content: 'Room',
  main_pc_contact: 'Contact',
  main_pc_location: 'Location',
  main_content_index: 'Home',
  main_content_workspace: 'Meeting Booking',
  main_meeting_available: 'Available',
  main_meeting_book: 'Book',
  main_meeting_more: ' Expand for More',
  main_meeting_startTime: 'Start Time ',
  main_meeting_endTime: 'End Time',
  main_meeting_attends: ' Participant',
  main_meeting_disuse: 'Disuse',
  main_meeting_attends_list: 'AttendsList',
  main_meeting_sign: 'No. of Check-in',
  main_meeting_sign_rate: 'SignRate',
  main_meeting_room_manager: 'Manger',
  main_meeting_use: 'Policy',
  main_meeting_attend: 'Participant',
  main_meeting_external: 'External',
  main_meeting_holder: 'Host',
  main_meeting_title: 'Title',
  main_meeting_room: 'Meeting Room',
  main_meeting_type: 'Type',
  main_meeting_description: 'Description',
  main_meeting_time_length: 'Time',
  main_meeting_notice: 'Remark ',
  main_meeting_ip: 'IP Phone',
  main_meeting_remark: 'Remark',
  main_meeting_message: 'SMS',
  main_meeting_cycle: 'Repeat',
  main_meeting_collapse: 'Collapse',
  main_meeting_no_data: 'No Data',
  main_meeting_room_rates: 'rate(yuan/hour)',
  main_meeting_cmma_type: 'Meeting Type',
  main_meeting_cmma_normal: 'Ordinary meeting',
  main_meeting_cmma_video: 'Video meeting',
  main_meeting_cmma_pwd: 'Password',
  main_meeting_cmma_pwd_wrong: 'Password must be number',
  meeting_control_btn: 'Control',
  cmma_msg_title: 'Edit subtitles',
  cmma_msg_label1: 'Duration (s)',
  cmma_msg_empty: 'Please enter a message within 60 words',

  mc_table_room: 'Meeting Room',
  mc_table_region: 'Region',
  mc_table_terminal: 'Terminal',
  mc_table_number: 'Number',
  mc_table_status: 'Status',
  mc_table_option: 'Option',
  mc_status_connected: 'Connected',
  mc_status_ringing: 'Ringing',
  mc_status_unknown: 'Unknown',
  mc_extend_message1:
    'The meeting will ended in {lastMinutes} minutes. Do you want to\n',
  mc_extend_message2: '\n?',
  mc_extend: 'extend',
  mc_btn_start_now: 'Start',
  mc_btn_add: 'Add',
  mc_btn_mute_all: 'Mute all',
  mc_btn_mute_all_cancel: 'Unmute',
  mc_btn_dial: 'Dial',
  mc_btn_lock: 'Lock',
  mc_btn_unlock: 'Unlock',
  mc_btn_layout: 'Layout',
  mc_btn_rotation: 'Rotation',
  mc_btn_message: 'Message',
  mc_btn_hang_up: 'Hang up',
  mc_btn_release: 'Release',
  mc_btn_subtitle: 'Subtitle',
  mc_btn_minute: 'Minute',
  mc_btn_hold: 'Hold',
  mc_btn_ok: 'OK',
  mc_btn_cancel: 'Cancel',
  mc_btn_select: 'Select',
  mc_btn_stop: 'Stop',
  mc_btn_main: 'Main',
  mc_btn_speaking: 'Speaking',
  mc_btn_video: 'Video',
  mc_btn_audio: 'Audio',
  mc_btn_redial: 'Redial',
  mc_label_stop_meeting: 'Whether to release meeting room resources?',
  mc_label_extend: 'Please select time to extend',
  mc_label_room_select: 'Select meeting room',
  mc_label_layout_model: 'Layout Model',
  mc_label_rotation_setting: 'Rotation Setting',
  mc_label_stop_rotation: 'Whether to stop rotation?',
  mc_layout_prefix_full: 'Full Screen',
  mc_layout_prefix_1_n: '1+N layout',
  mc_layout_prefix_equal: 'Equal layout',
  mc_layout_shortcut_speakerOnly: 'Full',
  mc_layout_shortcut_telepresence: 'Telepresence',
  mc_layout_shortcut_stacked: 'Stacked',
  mc_layout_shortcut_allEqual: 'Equal',
  mc_layout_speakerOnly: 'Full screen',
  mc_layout_telepresence: 'Telepresence',
  mc_layout_stacked: 'Stacked layout',
  mc_layout_allEqual: 'Equal layout',
  mc_layout_allEqualQuarters: '2*2 layout',
  mc_layout_allEqualNinths: '3*3 layout',
  mc_layout_allEqualSixteenths: '4*4 layout',
  mc_layout_allEqualTwentyFifths: '5*5 layout',
  mc_layout_onePlusN: '1+N layout',
  mc_layout_onePlusFive: '1+5 layout',
  mc_layout_onePlusSeven: '1+7 layout',
  mc_layout_onePlusNine: '1+9 layout',
  mc_layout_current: 'Current Model',
  mc_rotation_model: 'Rotation Model',
  mc_rotation_single: 'Single View',
  mc_rotation_multi: 'Multiple View',
  mc_rotation_interval: 'Interval',
  mc_rotation_mainLayout: 'Main Layout',
  mc_rotation_nums: 'Rotation Nums',
  mc_rotation_rotas: 'Rotations',
  mc_rotation_allParticipants: 'All Participants',
  mc_rotation_dot: ', ',
  mc_rotation_partiEnum: '{enumStr}, etc. A total of {num} meeting rooms',
  mc_msg_duplicate_number:
    'The number you are calling is already in the current meeting',
  mc_msg_at_least_one: 'Please select at least one new meeting room',
  mc_msg_no_meeting:
    "Video meeting hasn't started or ended and can't do this",
  mc_msg_main_warning:
    'Only the meeting room added when the meeting is created can be set as the main room',
  mc_msg_start_success: 'Video meeting started successfully',
  mc_msg_start_fail_0:
    'Failed to start the video meeting, resources occupied!',
  mc_msg_start_fail_1: 'Failed to start the video meeting!',
  mc_msg_start_already: 'Video meeting has already started',
  mc_msg_no_meeting_start:
    'There is no upcoming meeting in the current meeting room',
  mc_msg_no_email_start: 'The current user has not bind mail',
  mc_msg_close_then_back: 'Video meeting has already ended',
  mc_msg_calling_fail:
    'The meeting room {roomName} was occupied by other meetings',
  mc_msg_socket_error:
    'CMMA websocket closed, attempting to reconnect in 10 seconds.',
  mc_msg_success: 'Operate successfully, please wait a moment...',
  mc_subtitle_language: 'Language',
  mc_subtitle_translate: 'Translate',
  mc_subtitle_sublanguage: 'Sublanguage',
  mc_subtitle_language_zh: 'Chinese-Mandarin',
  mc_subtitle_language_en_u: 'English-US',
  mc_subtitle_language_en_a: 'English-Australia',
  mc_subtitle_language_kr: 'Korean',
  mc_subtitle_language_jp: 'Japanese',
  mc_subtitle_language_my: 'Malay',
  mc_subtitle_google: 'Only google support',
  mc_asr_config_error: 'Video play config exception',

  main_room_type: 'Room type',
  main_room_capacity: 'Room capacity',
  main_room_dept: 'Department',
  main_room_default_dept: 'Default Dept',
  main_sign_type: 'Sign type',
  main_is_sign: 'Check-in',
  main_open_video: 'Open Video',
  main_notice_type: 'Notification',

  main_meeting_room_placeholder_manager: 'Please select room manager',

  main_menu_title: 'Virsical Booking',
  main_menu_title_new: 'Virsical Smart  Meeting',
  main_menu_add: 'New shortcut',

  //预约
  reserve_type_video: 'Video',

  carouser_welcome: 'Welcome to join our booking system',
  carouser_welcome_1: 'More productivity & efficiency, any time & device.',
  carouser_welcome_2: 'Organize meeting from your calendar',
  carouser_welcome_3: 'Stand by you, more visible and ease.',
  carouser_welcome_4: 'Change Your Way With Cloud Trend ',
  carouser_welcome_5: 'Full support on-promise & cloud deployment.',
  carouser_welcome_6: 'Categorize & customize your service',
  carouser_welcome_7: 'Support  of customer defined facility & resource.',
  carouser_welcome_8: 'Role based user access control',
  carouser_welcome_9: 'Operate, process & more flexibility.',
  carouser_welcome_10: 'Mobility device supported ',
  carouser_welcome_11: 'It Included Android , IOS and Web browser now .',
  carouser_welcome_12: 'Share with your schedule at social Network.',
  carouser_welcome_13: 'Keep and share It , Anytime, where, device',

  index_bottom_1: 'Key Features ',
  index_bottom_2: 'Calendar',
  index_bottom_3: 'Meeting Booking',
  index_bottom_4: 'Web Meeting',
  index_bottom_5: 'Meeting Call',
  index_bottom_6: 'Customized Setting',
  index_bottom_7: 'User Management',
  index_bottom_8: 'Analystic & Report',
  index_bottom_9: 'Mobile APP',
  index_bottom_10: 'Product Demo',
  index_bottom_11: 'Value added services',
  index_bottom_12: 'Meeting room Door display',
  index_bottom_13: 'VS Call',
  index_bottom_14: 'Video Meeting',
  index_bottom_15: 'System Integration ',
  index_bottom_16: 'Price',
  index_bottom_17: 'Free Edition',
  index_bottom_18: 'Standard Edition',
  index_bottom_19: 'Enhanced Edition',
  index_bottom_20: 'About Us',
  index_bottom_21: 'About Company',
  index_bottom_22: 'Technical Support',
  index_bottom_23: 'News Room',
  index_bottom_24: 'Contact us',
  index_bottom_25: 'Wechat QR',
  index_bottom_26:
    'Company: Beijing Wafer New Century Information Technology Co. Ltd.',
  index_bottom_27:
    'Address: 19F 1907-1909 Tower E2 , Oriental Plaza No.1 East Chang An Ave, Dong Cheng Dist. Beijing, China',
  index_bottom_28: 'Product Hotline : 400-685-3160',
  index_bottom_29: 'Email:sales@virsical.com',
  index_bottom_30: '2000-2016 Wafer Systems Ltd',
  index_bottom_31: 'Beijing Wafer New Century Information Technology Co. Ltd.',
  index_bottom_32:
    'Recommend the use of Google, Firefox and IE10 versions of the browser, the resolution of 1280*800 and above.',

  account_base_info: 'Personal',
  city_zone: 'City & Area',
  account_setting: 'Setting',
  account_user_group: 'User',
  account_notice_remind: 'Notifications',
  account_server_resource: 'Meeting Room Management',
  account_domain_manage: 'Role Management',
  account_role_setting: 'Role Setting',
  account_role_list: 'Role List',
  account_meeting_book: 'Reserve for Others',
  account_meeting_manager: 'Meeting administrator',
  account_Authority_restriction: 'Permission Setting',
  account_meeting_setting: 'Setting of Reserving for others',
  account_new_more_meetings: 'Create multiple meetings at the same time',
  account_meeting_manager_setting: 'Administrator Setting',
  account_s: 'View Meetings Reservation Details of All areas',
  account_p: 'Edit & Cancel Unstarted Meeting of All areas',
  account_zone_add_value1: 'Please save it before adding it',
  reservation_save: 'Save',
  reservation_apply: 'Apply',
  reservation_send_notice: 'Send Notice',

  account_domain_address: 'Address',
  account_domain_ems: 'Post Code',
  account_domain_telephone: 'Mobile',
  account_domain_website: 'Website',
  account_domain_upload: 'Logo',
  account_domain_css: 'Theme',
  account_domain_css_1: 'Warm',
  account_domain_css_2: 'Dark ',
  account_domain_css_3: 'Customize',
  account_domain_lang: 'Language',
  account_domain_date: 'Time zone',
  account_app_Manager: 'AppManager',

  user_id: 'User ID',
  user_department: 'Department',
  user_company: 'Company',
  user_group: 'User Group',
  user_group_unit: 'Member',
  user_first_name: 'First Name',
  user_last_name: 'Last Name',
  user_position: 'Position',
  user_edit: 'Edit',
  user_delete: 'Delete',
  user_dept_notFound: 'Not Found',
  user_save_prompt: 'Add or modify user before save',
  user_not_edit: ' Prohibited modified or delete synchronized sser',
  resource_not_prompt: 'Add or modify user before save',

  group_name: "Group's name",
  group_name2: 'Name',
  group_save_prompt: "Input  group's name before save",
  group_select: 'Select group of item ',
  role_select: 'Please assign role of user',
  role: 'Role',
  domain_admin: 'super user',
  general_people: 'user',
  index_delete_success: 'Deleted successfully',
  index_save_success: 'Save successfully',
  index_save_failed: 'Save failed',
  index_meeting_save_failed: 'Failure of the appointment meeting',
  index_sync_success: 'Sync successfully',
  re_open: 'ON',
  re_close: 'OFF',
  resource_state_open: 'Unlock',
  resource_state_close: 'Lock',
  resource_open_open: 'Public',
  resource_open_close: 'Private',
  index_permission: 'Permission',
  index_device: 'Device Binding',
  re_to: ' To ',
  booking_before: 'Before ',
  booking_minutes: ' Minutes',

  privilege_time_limit: 'Time setting',
  work_time: 'Working hour',
  re_from: 'From',
  booking_win_num: 'Booking setting',
  booking_win: 'Early booking',
  re_shift: 'Before',
  lock_win: 'Min/Max Duration',
  re_day: 'Day',
  re_day_mini: 'day',
  re_hour: 'Hour',
  re_hour_mini: 'hour',
  re_minutes: 'Minute',
  re_min: 'Min',
  re_minutes_mini: 'minute',
  booking_number: 'Booking number',
  expire_number: 'Unused number',
  used_rate: 'Usage rate',
  self_service: 'Self-Service',
  workflow_approve: 'Approval',
  report_permission: 'Report',
  meeting_approve: 'Approval',
  meeting_detail: 'Detail',

  cycle_booking: 'Recurrence',
  cycle_times: 'times',
  cycle_may_booking: ' Available  ',
  bookingNum: 'bookNum',
  expireNum: 'expireNum',
  max_cycle_time: 'Maximum of repeat',
  max_booking_time: 'Maximum of time',
  re_other_setting: 'Other Setting',
  re_support: 'Support ',
  re_sign_in: 'Check',
  re_sign_out: 'In/Out',
  re_delay_time: 'Maximum of extending',
  re_add: 'Add',
  re_list: 'List',
  re_user: 'User',
  account_info: 'Account Information',
  re_date: 'Date',
  date_lang: '时间/语言设置',
  date_lang2: '时间设置',
  re_times: 'Times',

  re_of: 'Belong ',
  re_assist: ' Accessory',
  re_equipment: ' Equipment',
  re_service: 'Service',
  re_assist_server: 'Accessory Service',
  tea_break: 'Tea Break',
  re_number: ' Members',
  re_state_normal: 'Normal',
  re_state_fault: 'Fault',
  re_not_meeting:
    'Unavailable resources that match your search , Please change option & try Again ',
  re_personal_concat: 'Personal address book',
  re_company_concat: 'Company address book',
  add_external: 'Invite external guest',
  edit_external: 'Invite external guest',
  external_user: 'External guest',

  error_404: 'Oops~ ~ Bad page',
  error_tips: 'Please confirm URL is correct .',
  back_index: 'Back to home page',
  manual_add: 'Manually Add',
  excel_import: 'Excel Import',
  download_template: 'Template',
  re_upload: 'Upload',
  re_selected: 'Browse',
  send_invitation: 'Invite colleague',
  reset_password: 'Reset Password',
  old_password: 'Old password',
  new_password: 'New password',
  sure_password: 'Confirm password',
  old_password_notNull: 'Old password can not be empty!',
  new_password_notNull: 'New password can not be empty!',
  sure_password_notNull: 'Confirm password can not be empty!',
  sure_pwd_notEq: 'Confirm password is not equal new password!',
  new_password_tip: '8 or more digits, at least one number and one letter',
  new_pwd_check_err: 'Please enter more than 8 digits, at least one number and one letter!',
  company_info: 'Company',
  department_info: 'Department',
  device_info: 'Device',
  user_init_password: 'Initial Password Setting',
  init_password: 'Initial password',
  init_password_not_null: 'Initial password cannot be empty',

  my_reservation_list: 'My Booking',
  reservation_list: 'Booking List',
  re_week: 'Week',
  re_month: 'Month',
  re_month_mini: 'month',
  re_year: 'Year',
  re_year_mini: 'year',
  re_start: 'Start',
  re_end: 'End',
  re_extend: 'Extend',
  interval_time: 'Duration',
  regular_pattern: 'Recurrence',
  repeat_range: 'Start & End',
  no_end_time: 'No end date',
  re_repeat: 'Repeat',
  re_happen_time: 'Scheduled time',
  re_th: 'No.',
  re_every: 'Each',
  re_work_day: 'Every working day',
  re_week_day_new: 'working day',
  re_week_th: ' Weekly',
  re_week_thw: ' Weekly',
  re_month_th: 'Monthly',
  re_first: '1th',
  re_second: '2th',
  re_third: '3rd',
  re_fourth: '4th',
  re_sunday: 'Sunday',
  re_monday: 'Monday',
  re_tuesday: 'Tuesday',
  re_wednesday: 'Wednesday',
  re_thursday: 'Thursday',
  re_friday: 'Friday',
  re_saturday: 'Saturday',
  re_every_year: 'Annually',
  system_info: 'System Notification',
  we_chat_info: 'WeChat',
  email_info: 'Mail ',
  sms_info: 'SMS ',
  re_template: 'Template',
  notice_remind_set: 'Remind Setting',
  _30_minute: '30 minutes',
  _15_minute: '15 minutes',
  _10_minute: '10 minutes',
  _5_minute: '5 minutes',
  service_type_set: 'Categories setting',
  service_type_list: 'Categories List',
  service_type_permission: 'Permission Setting of Meeting Room Reservation',
  service_type_per_list: 'Meeting Room Reservation Permissions List',
  service_res_set: 'Meeting Room Setting',
  service_res_list: 'Meeting Room List',
  service_fixed_device_list: 'Fixed Device manage',
  service_mobile_device_list: 'Mobile Device manage',
  service_res_permission: 'Service Permission Setting',
  service_res_per_list: 'Service Resources Permissions',
  service_Exchange: 'Exchange',
  service_Office: 'Office365',
  service_Config: 'Service Config',
  service_Exchange_list: 'Exchange List',
  service_Exchange_protocol: 'Protocol',
  service_Exchange_versions: 'Versions',
  service_Exchange_status: 'Status',
  service_Exchange_describe: 'Description',
  service_Exchange_account: 'Account',
  service_Exchange_password: 'Password',
  service_Exchange_domain: 'Domain',
  service_Exchange_open: 'Enable',
  service_Exchange_close: 'Disable',
  service_exchange_connect: 'Connectivity test',
  sync_config: 'Sync Config',
  sync_config_port: 'Port',
  sync_config_roots: 'Sync Roots',
  sync_config_roots_msg: "Multiple OU with ', ' delimited",
  sync_config_oauthType: 'Oauth Type',
  sync_config_oauthMethod: 'Oauth Method',
  sync_config_encrypMode: 'Encryp Mode',
  sync_config_encrypMode_def: 'No Encryption',
  sync_config_filter: 'Filter',

  device_modal_title: 'Device Binding',
  device_modal_delete: 'Delete',
  device_modal_cancel: 'Cancel',
  device_modal_save: 'Save',
  device_modal_save_success: 'CMMA device binding success!',
  device_modal_save_fail: 'CMMA device binding failure!',
  device_modal_delete_success: 'CMMA device delete success!',
  device_modal_delete_fail: 'CMMA device delete failure!',
  device_modal_name: 'Name: ',
  device_modal_name_ph: 'CMMA Device Name',
  device_modal_cucmname: 'CUCM Name: ',
  device_modal_cucmname_ph: 'Use CUCM Device Name',
  device_modal_model: 'Model: ',
  device_modal_primaryAddress: 'Address: ',
  device_modal_primaryAddress_ph: 'CMMA device address',
  device_modal_protocol: 'Protocol: ',
  device_modal_sipEncryption: 'SIP Encryption: ',
  device_modal_bandWidth: 'BandWidth: ',
  device_modal_qualityMains: 'Quality Mains: ',
  device_modal_qualityPresentation: 'Quality Presentation: ',
  device_modal_sendDouble: 'Send Double: ',
  device_modal_dualStreamMode: 'Dual Stream Mode: ',
  device_modal_bfcp: 'bfcp Mode: ',
  device_modal_name_less: 'Name can not be less than 3 characters',
  device_modal_name_more: 'Name can not be more than 50 characters',
  device_modal_name_required: 'Name is required',
  device_modal_cucmname_more: 'CUCM name can not be more than 50 characters',
  device_modal_cucmname_required: 'CUCM name is required',
  device_modal_model_required: 'Model is required',
  device_modal_primaryAddress_required: 'Number is required',
  device_modal_primaryAddress_wrong: 'Number is not correct',
  device_modal_primaryAddress_more: 'Number can not be more than 10 characters',
  device_modal_protocol_required: 'Protocol is required',
  device_modal_sipEncryption_required: 'SIP encryption is required',
  device_modal_bandWidth_required: 'BandWidth is required',
  device_modal_qualityMains_required: 'Quality mains is required',
  device_modal_qualityPresentation_required: 'Quality presentation is required',
  device_modal_tip_required: 'TIP is required',
  device_modal_sendDouble_required: 'Send double is required',
  device_modal_dualStreamMode_required: 'Dual stream mode is required',
  device_modal_bfcp_required: 'bfcp mode is required',
  device_modal_item_ciscoOther: 'Cisco Other',
  device_modal_item_thirdPart: 'Third Part',
  device_modal_item_required: 'Required',
  device_modal_item_optional: 'Optional',
  device_modal_item_prohibited: 'Prohibited',
  device_modal_item_unlimited: 'Unlimited',
  device_modal_item_dualStream: 'Dual Stream',
  device_modal_item_singleStream: 'Single Stream',
  device_modal_item_sandc: 'Server/Client Mode',
  device_modal_item_server: 'Server Mode',
  IP_not_empty: "IP can't empty",
  account_not_empty: "account can't empty",
  password_not_empty: "password can't empty",
  domain_not_empty: "domain can't empty",
  port_not_empty: "port can't empty",
  roots_not_empty: "roots can't empty",
  Exchange_not_empty: 'Please perfect Exchange configuration information',

  //new add
  operation_items: 'Operating items',
  upload_avatar: 'Upload Profile',
  user_group_setting: 'User Group',
  no_group: 'No user group',
  user_info_prompt: 'Please complete it that required user information',
  user_info_name: 'Last names and names can not be both empty !',
  confirm_prompt: 'Please make sure the information is correct',
  reg_tel_prompt: "Register's telephone format is incorrect.",
  reg_email_prompt: "Register's mailbox format is incorrect",
  reg_domain_prompt: 'The company domain name had been registered',
  company_name_prompt: 'Company name cannot be empty',
  reg_account_prompt: "Register's account can not be empty",
  company_domain_prompt: 'Company domain name format is incorrect',
  reg_firstName_prompt: "Register's first name cannot be empty.",
  reg_lastName_prompt: " Register's last name cannot be empty",
  reg_password_prompt: "Register's password does not match the rules",
  uri_domain_prompt: 'Please enter a domain name in the browser address bar.',
  tel_error_prompt: 'The phone number is incorrect. Please re-enter it.',
  reg_userId_prompt: 'account name format is incorrect. Please re-enter it.',
  email_error_prompt: 'Enter the mailbox is incorrect, Please re-enter',
  password_error_prompt:
    'The password you entered is wrong. Please re-enter it.',
  userId_domain_prompt:
    'User ID domain name and browser URL in the domain name is not consistent',
  had_book: 'Reserved',
  not_start: 'Coming',
  re_going: 'In progress',
  re_done: 'Ended',
  re_canceled: 'Canceled',
  re_auditing: 'Pending',
  re_audit_failed: 'Rejected',
  re_audit_success: 'Approved',
  modify_loop_meeting: 'Modify all repeat meeting of this series?',
  cancel_loop_meeting: 'Cancel all repeat meeting of this series?',
  cancel_normal_meeting: 'Cancel this meeting?',

  //7月21号
  sign_out_meeting: 'Are you sure to cancel it ?',
  cancel_meeting: 'Cancellation',
  book_meeting_attendee: 'Members exceeded than capacity of space',
  delete_service_prompt: 'Delete your selected?',
  not_allow_book: 'No Available for Booking ',
  re_modify: 'Modify',
  not_allow_cycle: 'No Available for Repeat  ',
  resource_name_meeting: 'Meeting  Reservation',
  resource_name_meeting_type: 'Reservation type',
  resource_name_workspace: 'WorkSpace Reservation',
  resource_name_visit: 'Visitor Management ',
  re_basic_info: 'Basic Information',
  end_meeting_success: 'Successful conclusion of the meeting',
  cancel_meeting_success: 'Successful cancellation of the meeting',
  //timeZone setting
  re_time_zone_1: '(GMT -12:00) Eniwetok, Kwajalein',
  re_time_zone_2: '(GMT -11:00) Midway Island, Samoa',
  re_time_zone_3: '(GMT -10:00) Hawaii',
  re_time_zone_4: '(GMT -9:00) Alaska',
  re_time_zone_5: '(GMT -8:00) Pacific Time (US &amp; Canada)',
  re_time_zone_6: '(GMT -7:00) Mountain Time (US &amp; Canada)',
  re_time_zone_7: '(GMT -6:00) Central Time (US &amp; Canada), Mexico City',
  re_time_zone_8: '(GMT -5:00) Eastern Time (US &amp; Canada), Bogota, Lima',
  re_time_zone_9: '(GMT -4:00) Atlantic Time (Canada), Caracas, La Paz',
  re_time_zone_10: '(GMT -3:30) Newfoundland',
  re_time_zone_11: '(GMT -3:00) Brazil, Buenos Aires, Georgetown',
  re_time_zone_12: '(GMT -2:00) Mid-Atlantic',
  re_time_zone_13: '(GMT -1:00 hour) Azores, Cape Verde Islands',
  re_time_zone_14: '(GMT) Western Europe Time, London, Lisbon, Casablanca',
  re_time_zone_15: '(GMT +1:00 hour) Brussels, Copenhagen, Madrid, Paris',
  re_time_zone_16: '(GMT +2:00) Kaliningrad, South Africa',
  re_time_zone_17: '(GMT +3:00) Baghdad, Riyadh, Moscow, St. Petersburg',
  re_time_zone_18: '(GMT +3:30) Tehran',
  re_time_zone_19: '(GMT +4:00) Abu Dhabi, Muscat, Baku, Tbilisi',
  re_time_zone_20: '(GMT +4:30) Kabul',
  re_time_zone_21: '(GMT +5:00) Ekaterinburg, Islamabad, Karachi, Tashkent',
  re_time_zone_22: '(GMT +5:30) Bombay, Calcutta, Madras, New Delhi',
  re_time_zone_23: '(GMT +5:45) Kathmandu',
  re_time_zone_24: '(GMT +6:00) Almaty, Dhaka, Colombo',
  re_time_zone_25: '(GMT +7:00) Bangkok, Hanoi, Jakarta',
  re_time_zone_26: '(GMT +8:00) Beijing, Perth, Singapore, Hong Kong',
  re_time_zone_27: '(GMT +9:00) Tokyo, Seoul, Osaka, Sapporo, Yakutsk',
  re_time_zone_28: '(GMT +9:30) Adelaide, Darwin',
  re_time_zone_29: '(GMT +10:00) Eastern Australia, Guam, Vladivostok',
  re_time_zone_30: '(GMT +11:00) Magadan, Solomon Islands, New Caledonia',
  re_time_zone_31: '(GMT +12:00) Auckland, Wellington, Fiji, Kamchatka',

  permission_message: 'Role of Permission',
  re_cycle: 'Working Hour',
  loop_meeting: 'Recurrence',
  re_cycle_meeting: 'Cycle meeting',
  _24_hour: 'Day and Night',
  attend_holder_conflict: 'Participants and host can not be duplicated',

  select_service: 'Select service',

  upload_tips:
    'your files that included special characters, please modify it .',
  password_different: 'check password input, keep it same',
  re_login_use: 'Please login to use',
  select_service_permission: 'Please select the number of services',
  view_all_news: 'View All',
  you_have: 'You have ',
  have_message_number: ' message(s)',
  re_ago: ' ago',
  re_accept: 'Accept',
  re_agree: 'Approve',
  re_refuse: 'Reject',

  //会议展板
  iShow_available: 'Available',
  iShow_occupy: 'Occupied',
  today_events: "Today's Events",
  iShow_book: 'Book It',
  no_meeting: "Empty Meeting Room's Information",
  current_event: 'Current Event',
  end_meeting: 'End',
  extend_meeting: 'Extend',
  iShow_member: 'Members',
  iShow_people: 'People',
  next_meeting: 'Next Event',
  upcoming_meeting: 'Upcoming Event',
  member_password: "Input Member's Password",
  please_input_invite: 'Input Meeting Number',
  holder_password: "Input Host's Password",
  iShow_ok: 'Done',
  iShow_bind: 'Blinding',
  iShow_repairs: 'Is there a need for repairs?',
  meeting_email: "Meeting Room's Mailbox",
  main_meeting_time: 'Meeting Schedule',
  choose_time: 'Time Schedule',
  index_un_meet: 'Input title of meeting',
  index_un_attend: 'Attendants',
  add_holder: 'Select holder',
  add_attend: 'Select participants',
  meet_console: 'Virsical Signage Console',
  back: 'Back',

  message_dash: 'Notification Dashboard',
  message_list: 'Message List',
  message_error_prompt: 'Please select the message you want to delete.',
  message_content: 'Content',
  approval_check: 'Process approval',
  no_check: 'Not approved',
  agree_check: 'Already approved',
  message_receive_time: 'Received time',
  re_current: 'a moment ago',
  re_account: 'Account',
  sign_success: 'Check-in success',
  sign_out_success: 'Check-out success',
  re_send: 'Re-Send',
  re_tel_number: 'Phone number',
  re_tel_validate: 'Verification Code',

  /*app*/
  fill: 'Please fill in',
  select: 'Please Choose it',
  submitDel: 'Are you sure to delete it?',
  submitCancel: ' Are you sure to cancel this meeting?',
  roomNum: 'Capability',
  meeting_holder: 'Host',
  add: 'Add',
  all_select: 'Select All',
  all: 'All',
  no_data: 'None of related data',
  avatar: 'Profile Picture',
  tel: 'Mobile Number',
  current_version: 'Current Version ',
  book_meetting: 'New Meeting',
  phone_book: 'Contacts',
  inform_remind: 'Notification & Remind',
  inform_remind_con: 'Related of information about My Reservation',
  mybook: 'My Reservation',
  history_book: 'Historical Records',
  mybook_con: 'My Reservation of list',
  meetting_info: 'Meeting information',
  sweep: 'Scan QR',
  sweep_con: 'Scan QR : Check in / Out',
  Weekday: 'Working Day',
  Everyday: 'Everyday',
  just_start: 'This feature will come soon！',
  app_notice: 'Notification',
  app_remind: 'Remind',

  app_notice_pull: 'Pull Down',
  app_notice_deliver: 'Release',

  //  威思客底部统一
  product_categories: 'Product Categories',
  smart_conference: 'Smart Meeting',
  access_management: 'Access Management',
  smart_cubicle: 'Smart Cubicle',
  smart_signage: 'Smart Signage',
  smart_office_portal: 'Smart Office Portal',
  download: 'Download',
  download_virsical: 'Download Virsical',
  download_v_chat: 'Download V-Chat for Business',
  download_smart_signage: 'Download Smart Signage',
  rsources: 'Resources',
  download_product: 'Download Product Color Page',
  download_typical: 'Download Typical Cases',
  interactive_center: 'Interactive Center',
  video_center: 'Video Center',
  virsical_help_center: 'Virsical Help Center',
  company_profile: 'Company Profile',
  partners: 'Partners',
  honors_qualifications: 'Honors & Qualifications',
  news: 'News',
  recruitment: 'Recruitment',
  index_bottom_55: 'Scan the two-dimension code below to',
  index_bottom_56: 'follow Virsical official Wechat account',
  piece: '',
  day: 'Day',
  Num: '',
  week: 'Week',
  searchBar_clear: 'clr',
  loading: 'loading...',
  read: 'Read',
  done: 'Done',
  distance_meeting: ' ',
  wrong_Internet: 'Network Error, Please Check the Network!',

  // meeting v4.2
  service_area: 'Location',
  service_area_name: 'City',
  service_area_building_location: 'Area',
  service_type: 'Service Type',
  service_fixed_device: 'Fixed Device',
  service_fixed_device_select: 'Select',
  service_is_approval: 'Approve',
  creat_meeting: 'Create',
  exact_search: 'Search By',
  meeting_list: 'Meeting Management',
  login_info: 'Login',
  check_address: 'Make sure mailbox is correct',
  meeting_room_first: ' Select which room at first',
  edit_meeting: 'Edit',
  view_meeting: 'View',
  userId: 'Employee ID',
  welcome: 'Welcome to Meeting schedule system',
  logout: 'Quit',
  holder_no_null: "Must input Host's name",
  room_no_null: 'Please select a meeting room.',
  meeting_name_not_null: 'Topic can not be empty.',
  meeting_name_less_than_3:
    'Meeting topics should not be less than three characters!',
  sign_time_no_null: 'Sign time can not be empty',
  start_time_no_available:
    'The start time can not be less than the current time',
  hen_people: 'Delegate',
  time_limit: 'Unlimited time',
  day_not_enable:
    'Some months are less than {value} days, and for these months the event will be scheduled for the last day of the month',
  book_meeting_people_less:
    'The number of participants is insufficient, and will it continue to operate?',
  book_meeting_people_more:
    'The number of participants exceeds the limit of the meeting room. Do we continue to operate?',
  meeting_room_delete_success: 'Successful deletion of meeting rooms',
  meeting_room_delete_fail: 'Meeting Room Deletion Failed',

  room_types_common: 'Common Room',
  room_types_webex: 'Webex Room',
  room_types_acano: 'Acano Room',
  room_types_exchange: 'Exchange Room',
  room_types_domino_notes: 'Domino|Notes Room',
  room_types_google_calendar: 'Google Calendar Room',
  room_types_immediate: 'Infrared occupancy and use room',
  room_types_cisco_cmma: 'Cisco Video Room',

  //search
  time_type_month: 'Month',
  time_type_week: 'Week',
  time_type_day: 'Day',
  time_format_M: 'MMMM YYYY',
  time_format_w: 'MMMM YYYY',
  time_format_d: 'ddd LL',
  time_format_week: 'ddd',
  search_unit_person: '{num} People',
  search_right_menu_details: 'View',
  search_right_menu_edit: 'Edit',
  search_right_menu_cancel: 'Cancel',
  time_expired:
    'The time period has passed, Please select the appropriate time to create the meeting',
  search_page_end: 'Do not Click & Refresh, has been the end, no other data',
  reservation_submit: 'OK',
  search_room_close: 'The meeting room is not available for this time period',
  re_last: 'The last one',
  domain_account: 'Domain ID (Employee ID)',
  domain_password: 'Domain password (Employee activation password)',
  quick_search: 'Quick find',
  welcome_info: 'Welcome to Virsical Smart Meeting',
  index_login2: 'Login',
  code_tips: 'Validation code is sent',
  projector: 'Projector',
  phone: 'Phone',
  white_board: 'White Board',
  video: ' Video',
  error_info_new: 'OK',
  head_portrait_max: 'Profile picture size is {num}KB below',
  logo_max: 'LOGO picture size is {num}KB below',
  background_max: 'Background picture size is {num}MB below',
  skin_max: 'Theme picture size is {num}MB below',
  image_format_error: 'Formatted picture is jpeg/jpg/png',
  image_upload_error: 'Upload is failed, Try it later',
  image_upload_not_null: 'Please select photo',
  meeting_right: 'Only for attendees to View',
  upload_excel: 'Only support Excel file.',
  user_id_tip: 'User ID only support Character, Num,_and-',
  mobile_number_not_empty: "Mobile can't empty",
  mobile_number_format_error: 'Mobile must be number',
  domain_user_change: 'Domain administrators can not modify their roles',
  image_user_upload_info:
    'Picture Resolution:300*300       Format: jpeg/jpg/png.      Size: less than 500K.',
  image_bac_upload_info:
    'Picture Resolution:1920*1080       Format: jpeg/jpg/png.      Size: less than 2M.',
  image_logo_upload_info:
    'Picture Resolution:200*600       Format: jpeg/jpg/png.      Size: less than 500K.',
  more_meeting_booking: 'Booking more meeting',
  no_more_meeting: 'No optional meeting room',
  time_check: 'min 30(min)，max 180(min)',
  id_number_not_empty: "User ID can't empty",
  first_name_not_empty: "First Name can't empty",
  give_name_not_empty: "Last Name can't empty",
  email_not_empty: "Email can't empty",
  first_given_not_empty: 'First names and names can not be both empty',
  user_not_login: 'User is not logged in, please login first',
  meeting_extend_time_null: 'The extension of the meeting should not be empty!',
  meeting_extend_time_success: 'Successful extension of the meeting!',
  //iShow
  select_time: 'Select time',
  day_time: 'Date+Time',
  //time out
  fetch_time_out: 'Request timeout, please check the network.',

  //会议4.3
  add_more_meeting: 'Add more meeting room',
  pls_more_meeting: 'Please select meeting room',
  ordinary_meeting: 'Ordinary meeting room',
  video_meeting: 'Video meeting room',
  meeting_type: 'Meeting room type',
  meeting_device: 'Meeting room equipment',
  meeting_search_device: 'Meeting device',
  device_baiban: 'Whiteboard',
  device_touying: 'Projection',
  device_video: 'Video',
  device_phone: 'Phone',
  area_maintain: 'Area maintain',
  search_result: '{name} etc {num} results',
  meeting_management: 'Meeting administrator',
  meeting_rejected: 'Rejected',
  meeting_no_approved: 'Pending approval',
  meeting_other_no_approved: 'Wait for other approval',
  meeting_agree: 'Approved',
  remark_title: 'Remarks (description)',
  receipt_accept: 'Join',
  receipt_no_accept: 'No participation',
  receipt_back: 'Back to Index',
  regional_maintenance_title: 'Area Setting',
  new_regional_maintenance: 'Add Area',
  regional_maintenance: 'Area Management',
  regional_maintenance_edit_tip:
    'This action will discard the changes, do you continue? ',
  regional_maintenance_edit_tip_placeholder: 'Please enter 1-50 characters',
  department_maintenance_title: 'Department Setting',
  new_department_maintenance: 'New Department',
  department_maintenance_edit_tip:
    'This action will discard the changes, do you continue? ',
  department_maintenance_edit_tip_placeholder: 'Please enter 2-18 characters',
  need_audit: 'Need Audited',
  need_sign: 'Check-in',
  re_review: 'Pending',
  zone_no_select: 'No Eligible',
  pls_check_zone: 'Please choose a zone',
  pls_check_dept: 'Please choose a department',
  pls_check_depart: 'Please choose a department',
  pls_check_default_dept: 'Please choose a default department',
  pls_select_device: 'Please choose devices',
  pls_check_building: 'Please choose a building',
  re_date_time: 'Booking Time',
  //应用管理
  application_management: 'Software',
  upload_type: 'Type',
  upload_NewVersion: 'Upload New Version',
  version_list: 'Version List',
  version: 'Version',
  version_profile: 'Version Introduction',
  state: 'Status',
  open: 'Enable',
  close: 'Disable ',
  upload_file: 'Upload File',
  meeting_border: 'Meeting Signage',
  meeting_booking: 'Booking Meeting',
  format_error: 'File format should be .apk',
  version_format_error:
    'Please input correct version No. as XXX.XXX.XXX(X should be number)',
  version_format: 'Version introduction should be in 50 words',
  download_title: 'Download',
  meeting_signage: 'Meeting Signage',
  download_text1:
    'It enables you to push and display message about the meeting room booking via Outlook/Exchange, Google, OA, mobile apps, etc. You can also operate the Signage for booking, Check-in, check-out, postponing and the like in an interactive way.',
  download_text2: 'Meeting Signage',
  download_text3: 'Smart Meeting',
  download_text4: 'For iOS APP',
  download_text5: 'Android Tablet',
  download_text6: 'iOS APP',
  download_text7: 'Android APP',
  no_download:
    'No available version to download, please contact administrator！',
  upload_info_prompt: 'Please complete it that required upload information',
  ex_status_link: 'United',
  ex_have_link: 'Connected',
  ex_status_unlink: 'Ununited',
  ex_have_unlink: 'Disconnected',
  re_reset: 'Reset',
  upload_success: 'Upload Success',
  select_file: 'Select File',
  loreal_check_in: 'Check In',

  //report
  report_report: 'Report',
  report_search: 'Search',
  report_meeting: 'Meeting Room',
  report_percent: 'Percentage',
  report_detail: 'Details',
  report_meeting_title: 'Report/Room Usage Report',
  report_meeting_list_title: 'Report/Meeting Report',
  report_meeting_release_title: 'Report/Meeting Release Report',
  report_room_occupy_title: 'Report/Room Occupancy Report',
  report_area: 'Location',
  report_meeting_name: 'Room Name',
  report_holder_name: 'Holder',
  report_meeting_date: 'Meeting Date',
  report_meeting_time: 'Meeting Time',
  report_meeting_theme: 'Topic',
  report_room_name: 'Room Name',
  report_pls_name: 'Enter a name',
  report_pls_name_f: 'Add semicolon with end when enter more name',
  report_pls_holder_f: 'Enter a holder',
  report_room_place_holder: 'Room List',
  report_date: 'Date',
  report_unit: 'Meeting room * Percentage',
  report_no: 'No.',
  report_meeting_no: ' Meeting Num',
  report_sign_num: 'No. of Check-in',
  report_sign_time: 'Check-in time',
  report_occupancy_time: 'Occupancy(h)',
  report_occupancy_rate: 'Occupancy',
  report_booking_rate: 'Booking Rate',
  report_use_rate: 'Usage Rate',
  report_disuse_rate: 'Unused Rate',
  report_occupancy_info: 'Occupancy Info',
  report_used_info: 'Usage Rate Info',
  report_booking_disuse_info: 'Unused Booking Info',
  report_roomDetail_dayNum: 'Days',
  report_roomDetail_bookNum: 'No. of Booking',
  report_roomDetail_cancelNum: 'Cancel Times',
  report_roomDetail_earlyNum: 'No. of Early End Times',
  report_roomDetail_delayNum: 'No. of Extend',
  report_roomDetail_disuseNum: 'Disuse Times',
  report_roomDetail_unSignNum: 'UnSign Times',
  report_roomDetail_unSignNames: 'Not Checkin Names',
  report_roomDetail_num: 'Times',
  report_roomDetail_title: 'Report/Meeting room occupancy/Room detail',
  report_roomDetail_back: 'Back',
  report_roomDetail_chart:
    'Comparison of the number of meeting rooms and the number of non Check-in',
  report_roomDetail_detail: 'Details of the occupancy rate',
  report_occupancy_detail: 'Overview of Meeting Room Occupancy',
  report_room_occupy_popular: 'Hot Index of Meeting Room Usage Period',
  report_display: 'display more item',
  report_custom: 'Custom Report',
  report_custom_add: 'Create',
  report_custom_delete: 'Delete',
  report_custom_view: 'View',
  report_custom_delete_confirm: 'Are you sure delete this custom report?',
  report_custom_name: 'Name',
  report_custom_sql: 'SQL',
  report_custom_btn_excute: 'Run SQL',
  report_custom_btn_save: 'Save',
  report_custom_name_placeholder: 'Please input report name',
  report_custom_sql_placeholder: 'Forbidden SQL Keyword',
  report_custom_sql_null: 'Please input SQL script',
  report_custom_sql_keyword_invalid: 'Illegal SQL keyword',
  report_custom_sql_fenhao_forbidden: 'Do not use semicolons',
  report_custom_sql_querry_success: 'Query execution successfully',
  report_custom_save_success: 'Report saved successfully',
  report_custom_delete_success: 'Report delete successfully',
  report_abnormal_detail_page: 'Abnormal Detail',
  report_room_detail_page: 'Room Detail',

  report_abnormal_statis_report: 'Report',
  report_abnormal_meeting_statis: 'Meeting Room Abnormal',
  report_abnormal_meeting_detail: 'Meeting Room Abnormal Detail',
  report_abnormal_user_statis: 'User Reservation Report',
  report_abnormal_user_detail: 'User Abnormal Detail',
  report_abnormal_back: 'Back',
  report_abnormal_normal: 'Normal',
  report_abnormal_cancel: 'Cancel',
  report_abnormal_extend: 'Extend',
  report_abnormal_normal_f: 'Normal',
  report_abnormal_cancel_f: 'Cancel',
  report_abnormal_extend_f: 'Extend',
  report_abnormal_early_end: 'Early End',
  report_abnormal_cancel_num: 'Cancel({num} Time)',
  report_abnormal_extend_num: 'Extend({num} Time)',
  report_abnormal_early_end_num: 'Early End({num} Time)',
  report_abnormal_normal_num: 'Normal({num} Time)',
  report_abnormal_detail_dept: 'Department',
  report_abnormal_detail_creater: 'User',
  report_abnormal_detail_meeting_name: 'Meeting Name',
  report_abnormal_detail_meeting_time: 'Meeting Time',
  report_abnormal_detail_operate_time: 'Operation Time',

  //report  user
  report_user_title: 'Report/User Usage Report',
  report_user: 'User',
  report_user_pls_name: 'Enter a name',
  report_user_pls_name_f: 'Add semicolon with end when Enter more name',
  report_user_dept: 'Department',
  report_user_userDept: 'Department',
  report_user_bookTimes: 'Booking Times',
  report_user_time: 'Duration of Use',
  report_user_usage: 'Usage',
  report_download: 'Export',
  report_time_length: 'Time',

  //service +
  service_room_img: 'Room image',
  service_sign_noneed: 'No Check-in',
  service_sign_password: 'Authentication',
  service_sign_Invitation: 'Invitation',
  service_sign_qr: 'Qr code',
  service_sign_face: 'Face Recognition',
  service_sign_anonymous: 'Anonymous Check-in',

  meeting_file: 'files',
  meeting_file_upload: 'Upload file',
  meeting_file_notice_0_size: 'can not upload 0 size file',

  meeting_cal_meeting_infor: 'Meeting Info',

  meeting_reserve_status_status0: 'Scheduled',
  meeting_reserve_status_status1: 'Started',
  meeting_reserve_status_status2: 'Ended',
  meeting_reserve_status_status3: 'Canceled',
  meeting_reserve_status_status4: 'Approver Rejected',
  meeting_reserve_status_status5: 'Approver Pending',
  meeting_reserve_status_status6: 'Archived',

  meeting_status_2: 'The meeting is over.',
  meeting_status_3: 'The meeting has been cancelled.',

  meeting_remind_message_mail_webex_reason: 'The Meeting Is Not Exist',
  meeting_remind_message_mail_webex_reason_holder: "The Meeting Has Not Begun, Please Open Ten Minutes Early",
  meeting_remind_message_mail_webex_reason0: 'The holder has not opened the meeting, please wait',
  meeting_remind_message_mail_webex_reason1: 'The Meeting Is Going On',
  meeting_remind_message_mail_webex_reason2: 'The Meeting Is Over',
  meeting_remind_message_mail_webex_reason3: 'The Meeting Has Been Cancelled',
  meeting_remind_message_mail_webex_reason4: 'The Review Meeting Does Not Pass',
  meeting_remind_message_mail_webex_reason5: 'The Meeting Is Reviewing',
  meeting_remind_message_mail_webex_reason6: 'The Meeting Is Already Started',
  meeting_remind_message_mail_webex_reason7: 'The Webex Meeting Does Not Start',
  meeting_remind_message_mail_webex_startWebex: 'Start Webex',
  meeting_remind_message_mail_webex_joinWebex: 'Joining Meeting',
  meeting_remind_message_mail_webex_startTel: 'Start Tel',
  meeting_reserve_message_mail_webex_name: 'Topic',
  meeting_reserve_message_mail_webex_rooms: 'Room',
  meeting_reserve_message_mail_webex_creator: 'Creator',
  meeting_reserve_message_mail_webex_holder: 'Host',
  meeting_reserve_message_mail_webex_users: 'Attendees',
  meeting_reserve_message_mail_webex_startTime: 'Start Time',
  meeting_reserve_message_mail_webex_endTime: 'End Time',
  meeting_reserve_message_mail_webex_remark: 'Remark',
  meeting_reserve_message_mail_webex_status: 'Status',

  meeting_detail_webex_email_empty: 'Webex attender\'s email can not be empty!',

  board_no_data: '0',

  door_access_notice_msg: 'please use the qr code to sign or open the door.',

  smartDevice_notice_url_empty: 'Smart device address can not be empty',
  smartDevice_notice_key_empty: 'Smart device key can not be empty',
  access_notice_url_empty: 'Access service address can not be empty',
  access_notice_key_empty: 'Smart device service client id can not be empty',
  smart_device_server: 'Smart device service',
  smart_device_server_open: 'Smart device service switch',
  smart_device_placeholder_url: 'Service address',

  access_device_server: 'Access service',
  access_device_server_open: 'Access service switch',
  smart_device_button_save: 'Save',
  access_device_placeholder_door_code:
    'Enter multiple door, the door between use English ", "space',

  device_light: 'Smart light',
  device_outlet: 'Smart outlet',
  device_curtain: 'Smart curtain',
  access_no: 'Access No',

  smart_device_closed: 'Smart device service has closed',
  access_device_closed: 'Access service has closed',

  smart_device_drop_down_no_data: 'No data',

  device_submit: 'Save',
  device_fixed_title: 'Fixed Device',
  device_fixed_name_label: 'Fixed Device Name',
  device_fixed_num_label: 'Fixed Device Number',
  device_fixed_name_empty: 'Please input device name',
  device_fixed_num_empty: 'Please input device number',
  device_mobile_title: 'Mobile Device',
  device_mobile_name_label: 'Mobile Device Name',
  device_mobile_nums_label: 'Mobile Device Numbers',
  device_mobile_name_empty: 'Please input device name',
  device_num_not_null: 'Input device number please',
  device_nums_not_null: 'Input the number of device please',
  device_name_not_null: 'Input device name please',
  service_device_select: 'Fixed Device List',
  service_device_selected: 'Selected Device List',

  attend_select_amount: 'Selected {value} persons',
  attend_delete_user: 'Are you sure to delete user {value}?',

  monitor_panel: 'Panel monitor',
  monitor_panel_meeting_room: 'Room',
  monitor_panel_status: 'Status',
  monitor_panel_search: 'Search',
  monitor_panel_result: 'Result: total {value} block display exception',
  monitor_panel_area: 'Select Area',
  monitor_panel_room_name: 'Room',
  monitor_panel_position: 'Position',
  monitor_panel_operation: 'Operation',
  monitor_panel_repair: 'Repair',
  monitor_panel_delete: 'Delete',
  monitor_panel_status_all: 'All',
  monitor_panel_status_normal: 'Normal',
  monitor_panel_status_apperror: 'APP Error',
  monitor_panel_status_h5error: 'Web Error',
  monitor_panel_more: 'More',
  monitor_panel_repair_APP: 'Restart APP',
  monitor_panel_repair_H5: 'Refresh Web',
  monitor_panel_repair_restart: 'Restart Panel',
  monitor_panel_refresh_all: 'Refresh all',
  monitor_panel_refresh_warning: 'Are you sure you want to refresh it?',

  monitor_alarm_set: 'The alarm set',
  monitor_alarm_frequency: 'Alarm frequency setting',
  monitor_alarm_every_set: 'Every abnormality alarms',
  monitor_alarm_follow_set: 'Follow the settings to alarm',
  monitor_alarm_every: 'Every',
  monitor_alarm_minutes: 'minutes',
  monitor_alarm_times: 'times abnormal alarm',
  monitor_alarm_mailbox: 'Alarm recipient mailbox',
  monitor_time: 'Monitor Time',
  monitor_alarm_input_rule: 'Input multiple email addresses ; separated',
  monitor_alarm_apply: 'Apply',
  monitor_alarm_intervalTime_error: 'Please fill in the alarm interval.',
  monitor_alarm_frequency_error: 'Please fill in the alarm times.',
  monitor_alarm_email_error: 'Please fill in the correct email format.',

  application_size_lt_100: 'Application file can not larger than 100 Mb',

  //头像上传页面
  face_header_h4: '信息录入',
  face_header_p1: '您好',
  face_header_p2: '您有一些信息需要提交',
  face_body_name: '姓名：',
  face_body_dept: '部门：',
  face_body_face: 'Upload Face Recognition Photos: ',
  face_body_select: '选择照片',
  face_body_submit: '提交',
  face_body_tip: '祝您工作愉快。',
  face_footer_tip1: '海银金融控股集团有限公司',
  face_footer_tip2: '联系电话：+86(21)8013 3999',

  //地图信息页面
  map_header_h4: '地图信息',
  map_header_p1: '您好',
  map_body_room: '会议室：',
  map_body_daoyin: '地图导引：',

  service_cleaning_manage_title:'Cleaner Management',
  service_add_cleaning_manage_title:'Add Cleaning Personnel',
  service_back_to_service_manage_title:'Back to Service Management',
  service_new_level: 'New Level',
  service_new_item: 'New Services',
  service_edit_item: 'Edit services',
  service_item_manage: 'Management',
  service_level: 'Level',
  service_item: 'Items',
  service_item_item: 'Items',
  service_item_name: 'Name',
  service_item_price: 'Price',
  service_item_unit: 'Unit',
  service_item_type: 'Type',
  service_item_select: 'Service Items',
  service_item_if_number: 'Number',
  service_item_if_remark: 'Remark',
  yes: 'Yes',
  no: 'No',
  service_item_price_format: 'Format: 0.00',
  service_need_number: 'Need the quantity',
  service_need_number_explain: 'Note: When set to off, users do NOT need to enter the number of service items.',
  service_need_remark: 'Need the remark',
  service_need_remark_explain: 'Note: When set to off, users do NOT need to enter the notes.',
  service_need_describe_explain: 'When set to off, this information is as a description message, and set to on, this information is as a placeholder for an input box.',
  service_delete_data: 'Are you sure you want to delete this data?',
  service_level_error: 'Please fill in the service class name!',
  service_level_same: 'Service level names cannot be the same!',
  service_svcIds_error: 'Please select at least one service item!',
  service_item_error: 'Please fill in the service name!',
  service_price_error: 'Please fill in the service unit price!',
  service_unit_error: 'Please fill in the service unit!',
  service_type_error: 'Please select the service category!',
  service_remark_error: 'Please fill in the note information!',

  fault_yesterday_fault_statistics: 'Failure statistics yesterday',
  fault_7_fault_statistics: '7-day Fault Statistics',
  fault_fault_statistics: 'Failure Statistics',
  fault_7_fault_number: '7-day Failure Number',
  fault_top5: 'Troubleshooter TOP5',
  fault_number_of_failures: 'Failures',
  fault_failures_rate: 'Rate',
  fault_times: 'times',
  fault_select_time: 'Select Time',
  fault_select_time_placeholder: 'Please select time',
  fault_search_button: 'Query',
  fault_number_of_failures_title: 'Number',
  fault_time_error: 'The start time cannot be greater than the end time',
  fault_zone_error: 'Please select the region after the query',
  audit_reject_reason: 'Reject Reason',
  audit_reject_reason_pre: 'Reject Reason: ',
  audit_reject_tip: 'Please fill in the reasons for rejection.',
  audit_svc_detail: 'Meeting Service Detail',
  audit_svc_audit: 'Meeting Service Audit',
  audit_svc_no_need_audit: 'No Audit Required',
  audit_reject_tip_title: "Reject Reason: ",

  //系统个性化设置
  per_a_1: 'System LOGO',
  per_a_2: 'Upload Chinese Logo',
  per_a_3: 'Upload English Logo',
  per_a_4: 'It is recommended to upload 200*600 pixel pictures in jpeg/jpg/png format with a size not exceeding 2M.',
  per_a_5: 'Meeting panel LOGO and background',
  per_a_6: 'It is recommended to upload 350*100 pixel pictures in jpeg/jpg/png format with a size not exceeding 2M.',
  per_a_7: 'Background',
  per_a_8: 'It is recommended to upload 1280*800 pixel pictures in jpeg/jpg/png format with a size not exceeding 10M.',
  per_a_9: 'SMS Signature',
  domain_sms_sign_hint:
    'The SMS signature cannot be empty, and must apply in short message platform in advance',
  per_a_10: 'Save',
  per_a_11: 'Email Header',
  per_a_12: 'Upload Email Header',
  per_a_13: 'It is recommended to upload 600*100 pixel pictures in jpeg/jpg/png format with a size not exceeding 300K.',
  per_a_14: 'User Initial Password',
  per_user_pwd_not_empty: 'The user initial password can not be null!',
  per_a_15: 'Initial Password',
  per_a_16:'System Name',
  per_a_17:'System Chinese Name',
  per_a_18:'System English Name',
  per_b_1: 'Upload failed',
  per_b_2: 'Confirm',
  per_b_3: 'Please select the correct picture format file',
  per_b_4: 'Image is too large',
  per_b_5: 'Save successfully!',

  //模板管理
  boardman_1_0: 'Template Management',
  boardman_2_0: 'Energy Saving Setting',
  boardman_2_1: 'Mode:',
  boardman_2_2: 'Disabled',
  boardman_2_3: 'Cycle mode (daily)',
  boardman_2_4: 'Working day mode (shutdown on holidays)',
  boardman_2_5: 'Boot time:',
  boardman_2_6: 'Shutdown time:',
  boardman_2_7: 'Boot time must be earlier than shutdown time!',
  boardman_2_8: 'Save',
  boardman_3_0: 'Version Update',

  meeting_placeholder_start_date: 'Start Date',
  meeting_placeholder_end_date: 'End Date',
  meeting_placeholder_name_id: 'Meeting Name or ID',
  meeting_placeholder_room: 'Select meeting room',
  meeting_placeholder_remark: 'Please enter meeting remarks',
  meeting_btn_create_normal_meeting: 'Create Meeting',
  meeting_btn_create_video_meeting: 'Video Meeting',
  meeting_btn_mine_book: 'My booking',
  meeting_btn_mine_attend: 'My invited',
  meeting_btn_mine_manage: 'My Manage',
  meeting_list_header_status: 'Status',
  meeting_list_header_convene: 'Belongs',
  meeting_list_header_advanced_search: 'Advanced Search',
  meeting_list_table_id: 'ID',
  meeting_list_table_subject: 'Topic',
  meeting_list_table_status: 'Status',
  meeting_list_table_room: 'Room',
  meeting_list_table_start: 'Start Time',
  meeting_list_table_end: 'End Time',
  meeting_list_table_creator: 'Creator',
  meeting_list_table_operate: 'Operation',
  meeting_list_operate_cancelText: 'Are you sure cancel this meeting?',
  meeting_list_operate_stopText: 'Are you sure stop this meeting?',
  meeting_list_operate_book_again: 'Booking',
  meeting_cancel_cmma_title: 'The video meeting is still ongoing',
  meeting_cancel_cmma_text: 'Please end the video meeting on the control page.',

  cleaning_manage_name:'Name',
  cleaning_manage_phone:'Phone',
  cleaning_manage_email:'Email',
  cleaning_manage_list:'Cleaner Management',
  cleaning_manage_operate:'Operation',
  role_manage_role_name: 'Role Name',
  role_manage_permission: 'Grant Permission',
  role_manage_operate: 'Operation',
  role_manage_user_list: 'User List',
  role_manage_edit: 'Edit',
  role_manage_delete: 'Delete',
  role_manage_delete_confirm: 'Are you sure delete this role？',
  role_manage_edit_role: 'Edit Role',
  role_manage_all: 'All',
  role_manage_emp_name: 'Employee Name',
  role_manage_time: 'Specified Time',
  role_manage_delete_user_role:
    "Are you sure you want to delete the user's role？",
  role_manage_delete_user_role_fail1:
    'The user has allocated the meeting room. Please remove it first, then delete it.',
  role_manage_add_user_success: 'User added success.',
  role_manage_add_user_pls: 'Please select the user you want to add.',
  role_manage_cant_del_your_self:
    'The role of the current user cannot be deleted',

  user_add_sub_dept: 'Add Sub Department',
  user_add_comp_dept: 'Add Sub Company/Department',
  main_btn_reset_pwd: 'Reset Password',
  main_search_keywords: 'Please input search keywords',
  meeting_dept_user_add: 'Add User',
  meeting_dept_user_edit: 'Edit User',
  meeting_dept_user_import: 'Excel Import',
  meeting_dept_delete_confirm: 'Are you sure delete?',
  meeting_user_delete_confirm: 'Are you sure delete this user?',
  meeting_pwd_reset_confirm: "Are you sure rest this user's password?",
  meeting_dept_user_import_success: 'Import Success',
  meeting_dept_user_file_failed: 'File upload failed',

  notice_manage_global_config: 'Global notification configuration',
  notice_manage_global_config_content:'Default notification setting for participants after booking successfully.',
  notice_manage_user_notice_config: 'Notification for User',
  notice_manage_user_notice_config_content: 'When booking a meeting, the booker can choose how to send the notification to participants.',
  system_manage_meeting_admin_success: 'Successful Setting up Meeting Room Administrator',
  system_manage_delay_time_config: 'Meeting Extension',
  system_manage_delay_time_config_content: 'Default duration of meeting extension based on PC Web and meeting panel.',
  system_manage_delay_time_config_success: 'Meeting Extension Configuration Preserved Successfully',
  system_manage_delay_time_config_fail: 'Meeting Extension Configuration Save Failed',
  system_manage_delay_time: 'Delay Time',
  system_manage_delay_time_desc: 'Segmentation with \'|\', no more than three',

  system_manage_infrared_check_time_title: 'Infrared meeting room nobody detection time',
  system_manage_infrared_check_time_desc: 'In the middle of the meeting, if the infrared meeting room is empty for a period of time, the meeting will be released or reminder email will be sent.',
  system_manage_infrared_check_time_pre: 'Nobody detection time: ',
  system_manage_infrared_check_time_warn: 'Please enter the correct detection time!',
  system_manage_board_useing: 'Being used',
  system_manage_board_error: 'Abnormal',
  system_manage_board_stop: 'Deactivated',
  system_manage_board_start: 'Use',

  notice_manage_sms: 'SMS',
  notice_manage_email: 'Email',
  notice_manage_vsk: 'Virsical',
  notice_manage_wechat: 'Wechat',
  notice_manage_dd: 'DingTalk',
  work_day_label_select_year: 'Select year',
  work_day_label_working_hours: 'Working hour',
  work_day_label_working_day: 'Working day',
  work_day_label_Holiday: 'Holiday',
  work_day_setting: 'Setting',

  Monday: 'Monday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday',
  Thursday: 'Thursday',
  Friday: 'Friday',
  Saturday: 'Saturday',
  Sunday: 'Sunday',
  work_day_btn_save: 'Save',
  work_day_warning_work_hour: 'Please choose the correct working hours!',
  work_day_working_day: 'Please choose the working day.',
  work_day_remind: 'Do you want to make the {date} {value} be set to {holiday}?',

  log_manage: 'Log management',
  log_manage_placeholder_operate_type: 'Please select the type',
  log_manage_placeholder_operator_id: 'Please input Operate Id',
  log_manage_btn_query: 'Query',
  log_manage_btn_reset: 'Reset',
  log_manage_operate_time: 'Operating time',
  log_manage_operator: 'Operator',
  log_manage_operate_type: 'Operation type',
  log_manage_log_info: 'Log info',

  port_manage_protocol: 'Protocol',
  port_manage_version: 'Version',
  port_manage_ip: 'Address',
  port_manage_account: 'Account',
  port_manage_password: 'Password',
  port_manage_describe: 'Describe',
  port_manage_btn_save: 'Save',
  port_manage_btn_connect: 'Connect',
  port_manage_btn_disconnect: 'Disconnect',

  device_manage_add_mobile: 'Add mobile device',
  device_manage_edit_mobile: 'Edit mobile device',
  device_manage_add_stable: 'Add stable device',
  device_manage_edit_stable: 'Edit stable device',
  device_manage_back: 'Back to device manage',
  device_manage_device_name: 'Device name',
  device_manage_device_name_cn: 'Device chinese name',
  device_manage_device_name_en: 'Device english name',
  device_manage_device_describe: 'Describe',
  device_manage_device_number: 'Number',
  device_manage_floor: 'Floor',
  device_manage_cancel: 'Cancel',
  device_manage_ok: 'OK',
  device_manage_warning_empty_name: 'Device name is required!',
  device_manage_warning_empty_name_cn: 'Device chinese name is required!',
  device_manage_warning_empty_name_en: 'Device english name is required!',
  device_manage_warning_empty_number: 'Number is required!',
  device_manage_warning_empty_floor: 'Floor is required!',
  device_manage_operate: 'Operation',
  device_manage_edit: 'Edit',
  device_manage_delete: 'Delete',
  device_manage_confirm_delete: 'Are you sure you want to delete this data?',
  device_manage_borrow_manage: 'Borrow Management',
  device_manage_stable_manage: 'Fixed Device Management',
  device_manage_mobile_manage: 'Mobile Device Management',
  device_manage: 'Device Management',
  device_manage_confirm_occupied: 'The device has been occupied by the following meeting rooms:',
  device_manage_confirm_cannot_delete: 'It is not allowed to be deleted.',
  device_manage_confirm_if_update: 'Is it still necessary to modify?',

  device_manage_meeting_time: 'Meeting time',
  device_manage_meeting_title: 'Topic',
  device_manage_meeting_room: 'Meeting room',
  device_manage_meeting_applier: 'Applicant',
  device_manage_meeting_device: 'Device',
  device_manage_number: 'Number',
  device_manage_lend_state: 'Lend state',
  device_manage_warning_edit_success: 'Modify success!',
  device_manage_warning_save_success: 'Save success!',
  device_manage_warning_delete_success: 'Delete success!',
  device_manage_area: 'Area',

  device_manage_lend: 'Lend',
  device_manage_give_back: 'Give back',

  device_manage_state_lend_able: 'Can be borrowed',
  device_manage_state_lending: 'Borrowing',
  device_manage_state_give_back: 'Returned',

  support_manage_front_empty: 'No data',
  support_manage_list: 'Meeting Support List',
  support_manage_receptionist_number: 'Receptionist Number',
  support_manage_name: 'Meeting Support Name',
  support_manage_operate: 'Operation',
  support_manage_btn_add: 'Add',
  support_manage_receptionist_edit: 'Edit',
  support_manage_oprate_edit: 'Edit',
  support_manage_oprate_delete: 'Delete',
  support_manage_edit_title: 'Edit Meeting Support',
  support_manage_edit_ok: 'OK',
  support_manage_edit_cancel: 'Cancel',
  support_manage_edit_name: 'Meeting Support Name',
  support_manage_edit_duplicate_name: 'Meeting support name duplication!',
  support_manage_edit_empty_name: 'Meeting support name can not be empty.',
  support_manage_delete_msg:
    'Are you sure you want to delete this meeting support?',

  service_need_upload_attachments: 'Upload attachments',
  service_need_upload_attachments_attention: "Note: When set to off, users can NOT upload attachments.",
  service_need_approve: 'Approve',

  modal_manage_name: 'Template Name',
  modal_manage_bind_meeting_name: 'Binding Meeting Name',
  modal_manage_operate: 'Operation',
  modal_manage_edit: 'Edit',
  modal_manage_delete: 'Delete',
  modal_manage_add: 'Add',

  modal_manage_version_title: 'Board Version Update',
  modal_manage_version_name: 'Name',
  modal_manage_version_name_placeholder: 'Please upload file',
  modal_manage_version: 'Version',
  modal_manage_version_placeholder: 'Please enter the version number',
  modal_manage_version_create_user: 'Create User',
  modal_manage_version_create_time: 'Creation Time',
  modal_manage_version_url: 'Download Address',
  modal_manage_version_desc: 'Update Description',
  modal_manage_version_status: 'Status',
  modal_manage_version_file: 'Apk File',
  modal_manage_version_desc_placeholder: 'Please enter an update description',

  modal_manage_edit_title: 'Template Setting',
  modal_manage_edit_version_title: 'Upload installation package',
  modal_manage_btn_ok: 'OK',
  modal_manage_btn_cancel: 'Cancel',
  modal_manage_btn_end: 'Early End',
  modal_manage_edit_template_name: 'Template Name',
  modal_manage_edit_template_name_placeholder: 'Input template name',
  modal_manage_edit_uploadlogo: 'Upload Logo',
  modal_manage_edit_uploadlogo_hint:
    'The image format can be JPEG / JPG / PNG, size less than 500K',
  modal_manage_edit_eng_uploadlogo: 'Upload English LOGO',
  modal_manage_edit_eng_uploadlogo_hint:
    'The image format can be JPEG / JPG / PNG, size less than 500K',
  modal_manage_edit_bg: 'Choose display background',
  modal_manage_edit_bg_hint:
    'The upload size is 1280*768 pixels. The format of the photo can be JPEG / JPG / PNG, not more than 2M.',
  modal_manage_meeting_room: 'Meeting room',
  modal_manage_meeting_room_Occupy:
    'This template is being used in the meeting room, and will be switched to the default template after deletion.',
  modal_manage_no_bg: 'Please upload the display panel background',
  modal_manage_no_eng_logo: 'Please upload LOGO pictures in English',
  modal_manage_no_logo: 'Please upload Chinese LOGO picture',
  modal_manage_no_template_name: 'Template name can not be empty',
  board_manage_big_image: 'Image file is too large',
  board_manage_has_apk: 'Apk already exist',
  board_manage_big_apk: 'Apk file is too large',
  board_manage_error_image_format:
    'Please select the correct picture format file',
  board_manage_error_apk_format: 'Please upload the APK file',
  modal_manage_board_version_occupy: 'Whether to Enable this Exhibition Board Version',

  upload_img_tip:
    'The recommended upload size is {w}*{h} pixels, and the photo format can be JPEG/JPG/PNG/BMP, with the size not exceeding {n}M.',
  upload_img_isLt: 'Picture size should not exceed {n}M',
  room_manage_list_name: 'Room Name',
  room_manage_list_zoneFullName: 'Area',
  room_manage_list_adminUserName: 'Administrator',
  room_manage_list_qr: 'QR',
  room_manage_list_qr_title: 'Show QR',
  room_manage_list_oprate: 'Operation',

  room_manage_repair: 'Maintain',
  room_manage_device_repair: 'Device Repair',
  room_manage_no_device_repair:
    'There is no equipment to be maintained in the meeting room',
  room_manage_delete_msg: 'Do you want to delete this meeting room?',
  room_manage_video_bind: 'Video Device Binding',
  room_manage_video_bind_suc: 'Video device binding successfully!',
  room_manage_video_bind_fail: 'Video device binding failed!',
  room_manage_video_delete_ok: 'Video device deleted successfully',
  room_manage_video_delete_fail: 'Video device deleted failed',

  room_manage_add_meeting_room: 'Add Meeting Room',

  room_manage_choose_meetingroom_admin: 'Select room admin',

  room_manage_bind: 'Bind',

  roomqr_manage: 'Show QR',
  roomqr_manage_close: 'close',
  roomqr_manage_download: 'Download',
  room_device_repair_title: 'device repair',

  room_device_fault: 'fault',
  room_device_normal: 'normal',

  room_add_modal_title:'Add Room',
  room_edit_modal_title:'Edit Room',
  room_manage_list:'Room manage list',
  room_edit_room_name:'Room Name',
  room_edit_room_nameEn: 'Room English name',
  room_edit_room_code:'Room ID',
  room_edit_belong_area:'Location',
  room_edit_area:'Area',
  room_edit_floor:'Floor',
  room_edit_email:'Email',
  room_edit_people_number:'Number of participants',
  room_edit_person:'participants',
  room_edit_cost:'Unit price of room',
  room_edit_unit_price:'Yuan/Hour',
  room_edit_room_type:'Room type',
  room_edit_placeholder_room_type:'Please select room type',
  room_edit_allow_apply_svc:'Meeting Service',
  room_manage_organization:'Organization',
  room_edit_sign_type:'Check-in type',
  room_edit_placeholder_sign_type:'Please select sign type',
  room_edit_need_audit:'Needs approval',
  room_edit_usage:'Enabled',
  room_edit_room_manage:'Room administrator',
  room_edit_fixed_device:'Facilities',
  room_edit_placeholder_fixed_device:'Please select facilities',
  room_edit_room_image:'Room picture',
  room_edit_room_order:'Room number',
  room_edit_placeholder_room_order:'Please input room number',
  room_edit_open_hw:'Infrared sensor',
  room_edit_cancel:'Cancel',
  room_edit_ok:'OK',
  room_edit_admin_warning: "The meeting room administrator must include you！",
  room_edit_wrong_num: "The maximum number of people in the meeting room cannot be less than the minimum number!",
  room_edit_device_maximum: 'The maximum number of stable device in the meeting room is 5',

  region_confirm_delete_record:'Confirm delete this data?',
  report_placeholder_meeting_room:'Please select meeting room',

  meeting_detail_start_now: 'Start Now',

  meeting_tab_meeting_info: 'Meeting information',
  meeting_tab_meeting_service_apply: 'Apply for meeting service',
  meeting_tab_meeting_sign: 'Check-in management',
  meeting_tab_meeting_agenda: 'Meeting agenda',
  meeting_tab_meeting_device_lend: 'Meeting device',

  meeting_device_add: 'Adding mobile devices',
  meeting_device_search: 'Please enter device name to search',
  meeting_device_type: 'Device type',

  meeting_info_initiate_auto: 'Auto Initiated',
  meeting_info_reconnect_auto: 'Auto Reconnect',
  meeting_info_cospaces: 'Meeting number',

  room_detail_room_type: 'Room type',

  policy_manage_meeting_lock_time: 'Meeting lock time',
  policy_manage_meeting_lock_time_content:
    'After the meeting, set the lock for a while before proceeding to the next meeting.',
  policy_manage_btn_save: 'Save',
  policy_manage_meeting_willend_time: 'Meeting willend notice',
  policy_manage_meeting_willend_time_content:
    'Time to send reminder notices before the end of the meeting',

  policy_manage_meeting_remind_time: 'Meeting remind time',
  policy_manage_meeting_remind_time_content:
    'Time to send reminder notices before the start of the meeting',
  policy_manage_before_meeting_start:'Before the meeting start',

  policy_manage_unrepresented_reminder: 'Unrepresented reminder',
  policy_manage_unrepresented_reminder_content:
    'Send notifications to people who are not attending, configure the time when the "Reminder" button on the meeting panel is displayed and hidden.',
  policy_manage_meeting_check_in_time: 'Meeting Check-in time',
  policy_manage_meeting_check_in_time_content:
    'Set the default Check-in time for the meeting.',
  policy_manage_meeting_lock: 'One-click lock meeting',
  policy_manage_meeting_lock_content:
    'Lock the meeting, infrared can not release the meeting.',
  policy_manage_room_maintain: 'Meeting room maintenance',
  policy_manage_room_maintain_content: 'Reservations are not allowed during meeting room maintenance.',
  policy_manage_webex_btn_switch: 'WebEx Meeting Settings',
  policy_manage_webex_btn_content: 'Setting up of WebEx Meeting Reservation Interface',
  policy_manage_display_board_btn_switch: 'Display button switch',
  policy_manage_meeting_function_btn_switch: 'Display function switch',
  policy_manage_display_board_btn_content: 'Switch on the board "reservation" and "extension", "end" button and two-dimensional code display.',
  policy_manage_meeting_function_btn_content: 'After closing the switch, the following functions will not be displayed',
  olicy_manage_meeting_cleaner_btn_switch: 'Cleaner notice switch',
  policy_manage_meeting_cleaner_btn_content: 'Send a notice to the cleaner after the meeting',
  policy_manage_if_lock: 'Whether to lock',
  policy_manage_if_show: 'Whether to show',
  policy_manage_if_notice: 'Whether to remind',
  policy_manage_time: 'Time',
  policy_manage_sign_time_label: 'before/after the meeting',
  policy_manage_before_meeting: 'Before the meeting',
  policy_manage_after_meeting: 'After the meeting',
  policy_manage_before_meeting_end: 'Before the meeting end',
  policy_manage_minute: 'minutes',
  policy_manage_day: 'Days',
  policy_manage_meeting_sign: 'Sign Manage',
  policy_manage_meeting_svc: 'Meeting Service',
  policy_manage_meeting_device: 'Meeting Device',
  policy_manage_meeting_agenda: 'Meeting Agenda',
  sign_meeting_befer_or_after: 'Before and after the meeting',
  need_room_admin_audit: 'Meeting in this room require approval from the room administrator.',
  external_contacts: 'Add External',
  meeting_service_apply_title: 'Apply for meeting service',
  meeting_service_apply_btn: 'Apply',
  meeting_service_apply_column_select: 'Select',
  meeting_service_apply_column_service_type: 'Service Type',
  meeting_service_apply_column_price: 'Price',
  meeting_service_apply_column_number: 'Number',
  meeting_service_apply_column_total: 'Total(Yuan)',
  meeting_service_apply_column_remark: 'Remark',
  meeting_service_apply_column_file: 'File',
  meeting_service_apply_label_total: 'Total',
  meeting_service_apply_label_yuan: 'Yuan',

  meeting_apply_success: 'Apply Success!',
  meeting_save_success: 'Save Success!',
  meeting_save_failed: 'Save Failed!',
  meeting_book_success: 'Booking Success!',
  meeting_cmma_number: 'Number',
  meeting_cmma_password: 'Password',
  meeting_cancel_success: 'Cancel Success!',
  meeting_send_msg: 'Send Message',
  meeting_attends_inner: 'Inner',
  meeting_attends_outer: 'External',
  meeting_book_column_invite: 'Invite',
  meeting_book_jurisdiction_fail: 'You do not have the right to reserve the meeting room, please contact the administrator!',
  imcomplete_external_info: 'Incomplete external contact information',

  personal_common_addr: 'Usual Address: ',
  personal_addr_config: 'Personal Common Address Configuration',

  app_index_conf_name: 'Function Name',
  app_index_conf_cancel_show: 'Cancel Display',
  app_index_conf_set_show: 'Set Display',

  app_index_book: 'Booking',
  app_index_about: 'About',
  app_index_video_meeting: 'Video Meeting',
  app_index_my_meeting: 'My meeting',
  app_index_initiate: 'Initiate Meeting',
  app_index_webex_meeting: 'WebEx Meeting',
  user_edit_cardNo: 'Card number',
  meeting_list_sign_state:'Sign State',

  meeting_list_table_not_sign: 'Not Check-in',
  meeting_list_table_sign:'Checked in',

  room_maintain_start_label: 'StartTime',
  room_maintain_end_label: 'EndTime',
  room_maintain_start_pls: 'Please select start time',
  room_maintain_end_pls: 'Please select end time',
  room_maintain_start_empty: 'Start time can not be empty',
  room_maintain_end_empty: 'End time can not be empty',
  room_maintain_status_normal: 'Normal',
  room_maintain_status_valid: 'Maintenance',
  room_maintain_start_less_than_now:'Start time can not less than current.',
  room_maintain_end_less_than_start:'End time can not less than start time.',

  mt_rls_kind_cancel: 'Cancelled',
  mt_rls_kind_normal: 'Normal',
  // 未签到释放
  mt_rls_kind_unsigned: 'Not Check-in',
  // 主动取消
  mt_rls_type_cancel: 'Cancelled',
  // 未签到
  mt_rls_type_unsigned: 'Not Check-in',
  // 提前结束
  mt_rls_type_early: 'End Early',
  // 红外释放
  mt_rls_type_infrared: 'By Sensor',

  mt_rls_type_time_up: 'On Time',
  mt_rls_type_delay: 'Extended',
  mt_rls_type_reject: 'Booking Rejected',
  mt_rls_type_third_syn: 'Third party sync',
  mt_rls_type_all_refused: 'Reject all',
  mt_rls_type_room_maintain: 'Maintenance in Progress',
  mt_rls_type_room_visible: 'Not Available',

  meeting_sign_btn_export:'Export',
  meeting_sign_label_sign_state:'State',
  meeting_sign_label_has_sign:'Checked in',
  meeting_sign_label_no_sign:'Not Check-in',
  meeting_sign_label_sign_type:'Check-in type',
  meeting_sign_label_sign_time:'Time',
  meeting_sing_label_unit_people:'person',
  meeting_sing_column_name:'Name',
  meeting_sing_column_sign_time:'Sign time',
  meeting_sing_column_sign_type:'Check-in type',
  meeting_sing_column_sign_img:'Head image',
  meeting_sing_column_sign_operation:'Operate',
  meeting_sign_column_resign:'Supplementary Check-in',

  meeting_sing_type_none:'--',
  meeting_sing_type_pwd:'Password Check-in',
  meeting_sing_type_qr_code:'Scan code Check-in',
  meeting_sing_type_face:'Face Check-in"',
  meeting_sing_type_infrared:'Infrared Check-in',
  meeting_sing_type_supplement:"Subscriber's patch",
  meeting_sing_type_anonymous:'Anonymous Check-in',
  meeting_sing_type_door_access:'Access control Check-in',

  license_title: 'License  config',
  license_subtitle:'config system license',
  license_label:'license:',

  sys_log_server_select: 'Server',
  sys_log_search_date: 'Date',
  sys_log_level: 'Level',
  sys_log_download: 'Download',
  sys_log_search_date_empty: 'Please select date',

  meeting_save_tips_subject:'Topic',
  meeting_save_tips_holder:'Host',
  meeting_save_tips_time:'Time',
  meeting_save_tips_reason:'Reason',
  meeting_save_tips_lock_time:'Lock time',
  meeting_save_tips_reason_0:'Time period occupied',
  meeting_save_tips_reason_1:'Conflict with other lock-in time',
  meeting_save_tips_reason_2:'Meeting Lock-in Time Occupied',
  meeting_save_tips_reason_3:'The holder has been occupied',
  meeting_tips_room_maintain:'Maintenance',
  meeting_tips_holiday:'Holiday',

  meeting_save_tips_yes:'Yes',
  meeting_save_tips_no:'No',

  meeting_save_tips_modal_title1:'The following period of time failed. Do you skip and continue booking?',
  meeting_save_tips_modal_title2:'The appointment failed in the following time period, and there is no bookable meeting!',
  meeting_sign:'Check-in',
  sign_manage_need_attend:'Need to Check-in',
  sign_manage_unit_people:'people',
  sign_manage_sign: 'checked in',
  sign_manage_not_sign:'Not Check in',
  sign_manage_sign_state:'Check-in status',
  sign_manage_sign_time:'Check-in time',
  sign_manage_sign_operation:'Operation',
  sign_manage_resign:'Instead of Check-in',
  sign_manage_status_has_sign:'Checked in',
  sign_meeting_check_in_time:'Check-in time',
  sign_manage_img:'Avatar',

  delay_meeting_sub_title:'Please choose to extend the meeting time',
  delay_meeting_select_time: '{time} minutes',
  delay_meeting_wish_tip: 'I Wish You a Happy Work.',
  delay_meeting_bottom_wafer: 'Wafer Systems Ltd',
  delay_meeting_loop_recurrence: 'Recurrence',

  room_name_comm: 'Common meeting rooms',
  message_agenda_value1: 'Theme, time, speakers can\'t all be empty!',
  message_broadcast_value1: 'Successful application for live broadcast!',
  message_send_msg_success: 'Successful notification',
  message_send_msg_fail: 'Failed to send notification',

  meeting_agenda_speaker: 'Speaker',

  meeting_services_info_value1: 'Please check the service items you need!',
  meeting_services_info_value2: 'The number of meeting services selected cannot be empty or zero!',
  meeting_services_info_value3: 'Notes on selected meeting services cannot be empty!',
  meeting_services_info_value4: 'Selected meeting services need to upload attachments!',
  meeting_services_info_value5: 'Please select mobile devices',
  meeting_services_info_value6: 'Opening Exchange Connection Operation Successful',
  meeting_services_info_value7: 'Successful update status',
  meeting_services_info_value8: 'New cleaning staff',
  meeting_services_info_value9: 'This service needs approval of the meeting service administrator. ',

  meeting_audit_fail_title: 'Approve failed!',

  user_check_user_id_info: 'Please input the user ID!',
  user_check_user_name_info: 'Please input the user name!',
  user_check_user_name_dep: 'Please select the department!',

  room_editor_check_okText: 'ok',
  room_editor_check_name: 'Please input the room name!',
  room_editor_check_nameEn: 'Please input the room english name!',
  room_editor_check_ord_min: 'The room order number can only be integers and not less than 1!',
  room_editor_check_ord_max: 'The order of room should not exceed 6 digits!',
  room_editor_check_zone: 'Please select the location!',
  room_editor_check_email: 'Please input the email!',
  room_editor_check_emailReg: 'The email format is incorrect!',
  room_editor_check_maxNumber: 'Please input the number of participants!',
  room_editor_check_minNumber: 'The max number of rooms should not be less than the min number!',
  room_editor_check_adminUserId: 'Please select the room administrator!',

  meeting_service_current_status: 'Current status: ',

  continue_book:'Continue',
  cancel_book:'Cancel ',
  cancel_apply:'Cancel',
  continue_apply:"Continue",
  meeting_fee_notice:'Book meeting amount: ',
  meeting_room_single_price:'Unit price of room: ',
  room_fee_unit_hour:'hour',
  room_fee_unit_minute:'minutes',
  room_fee_book_time:'Meeting time: ',
  room_fee_total:'Room fee: ',
  room_fee_during_time:'During time: ',
  meeting_svc_fee_total:'Meeting service fee: ',
  meeting_fee_total:'Total: ',
  notice_manage_label_billing:'Whether notice billing',
  notice_manage_billing_titile:'Booking meeting billing notice',
  notice_manage_billing_config_content:'Does the meeting room and conference service require billing notice when scheduling a meeting',
  yuan_every_hour:'yuan/hour',

  cross_days_meeting_days_limit:'The number of long-term meeting cannot be less than {num} days！',
  notice_manage_title_crossday_meeting_min_day:'Minimum number of days for long-term meetings',
  notice_manage_subtitle_crossday_meeting_min_day:'Minimum number of days for long-term meetings',
  notice_manage_label_crossday_meeting_min_day:'Number of days：',
  unit_day:'days',
  long_term_meeting_label:'Long-term meeting:',

  room_manage_offRoomSelect_msg: 'Please select at least one piece of data?',
  room_manage_Enable_meeting_room: 'Batch offline',
  room_manage_offline_msg: 'Whether to batch off the conference room?',
  room_manage_list_visible: 'Enabled state',
  meeting_list_selected_meeting_desc : 'Selected {num} data',
  meeting_manage_batchCancel_meeting_msg: 'Make sure to cancel the meeting?',
  meeting_room_off_fail: 'Failure to offline conference room',
  meeting_room_off_success: 'Successful offline conference room',
  room_manage__meeting_batchCancel: 'Batch cancellation',
  price_free:'Free',

  meeting_bill_report: 'Report',
  meeting_bill_report_time: 'Date :',
  meeting_bill_report_dept: 'Department :',
  meeting_bill_report_search: 'Search',
  meeting_bill_report_reset: 'Reset',
  meeting_bill_report_return: 'Return',
  meeting_bill_report_export: 'Export',
  meeting_bill_report_dept_user: 'Department/User',
  meeting_bill_report_room_price: 'Room costs（￥）',
  meeting_bill_report_svc_price: 'Service costs（￥）',
  meeting_bill_report_total_price: 'Total（￥）',

  // web端菜单栏
  menu_meeting_booking: 'Meeting Booking',
  menu_meetings: 'Meetings',
  menu_system_configuration: 'System Configuration',
  menu_cole_management: 'Cole Management',
  menu_meeting_panel_management: 'Meeting PanelManagement',
  menu_meeting_room_management: 'Meeting Room Management',
  menu_meeting_service_management: 'Meeting Service Management',
  menu_device_danagement: 'Device Management',
  menu_interface_setting: 'Interface Setting',
  menu_log_lanagement: 'Log Management',
  menu_report: 'Report',
  menu_room_usage_report: 'Room Usage Report',
  menu_user_usage_report: 'User Usage Report',
  menu_abnormal_room_report: 'Abnormal Room Report',
  menu_abnormal_user_report: 'Abnormal User Report',
  menu_meeting_report: 'Meeting Report',
  menu_workday_management: 'Workday Management',
  menu_system_management: 'System Management',
  menu_enterprise_info: 'Enterprise Setting',
  menu_meeting_panel_monitor_img: 'Meeting Panel Monitor',
  menu_meeting_panel_monitor: 'Meeting Panel Monitor',
  menu_fault_statistics: 'Fault Statistics',
  menu_approval: 'Approval',
  menu_meeting_approval: 'Meeting Approval',
  menu_meeting_service_approval: 'Meeting Service Approval',
  menu_department_user_management: 'Department User Management',
  menu_panel_alarm: 'Panel Alarm',
  menu_personal_information: 'Personal Information',
  menu_enterprise_setting: 'Enterprise Setting',
  menu_meeting_release_report: 'Meeting Release Report',
  menu_room_occupy_report: 'Room Occupancy Report',
  menu_meeting_bill_report: 'Meeting Bill Report',

};



// WEBPACK FOOTER //
// ./src/i18n/en_US/index.js